import TextField from '@mui/material/TextField';

export const FilterInputConfigError = ({
  filterLabel,
  message,
  type,
}: {
  filterLabel: string;
  message: string;
  type: string;
}) => {
  return (
    <TextField
      error={true}
      helperText={message}
      id="filled-error-helper-text"
      label={filterLabel || type}
      size="small"
      sx={{ maxWidth: 160 }}
      variant="filled"
    />
  );
};
